// extracted by css-extract-rspack-plugin
var _1 = "li";
var _2 = "h";
var _3 = "g";
var _4 = "b";
var _5 = "bc";
var _6 = "f";
export { _1 as "closeButton", _2 as "content", _3 as "inner", _4 as "modalComponent", _5 as "userCommunicationTemplateModalComponent", _6 as "wrapper" }
